export enum CourseTabs {
  TIMELINE = 'timeline',
  INFO = 'info',
  SYLLABUS = 'syllabus',
}
